<div class="title-row">
  <h2 class="headline-5">{{ titleKey | translate }}</h2>
  <div *visanaLibHideForBreakpoint="'for-XSmall-Down'">
    <ng-container *ngTemplateOutlet="dotsTemplate"></ng-container>
  </div>
  <div></div>
</div>

<div #viewportRef class="embla-viewport">
  <div #containerRef class="embla-container">
    <ng-content></ng-content>
  </div>
</div>

<div *visanaLibShowForBreakpoint="'for-XSmall-Down'">
  <ng-container *ngTemplateOutlet="dotsTemplate"></ng-container>
</div>

<ng-template #dotsTemplate>
  <div class="dots-wrapper" *ngIf="slideSelectionStates.length > 1">
    <button
      *ngFor="let selected of slideSelectionStates; let i = index"
      (click)="onDotClick(i)"
      [class.selected]="selected"
      class="dot"
    ></button>
  </div>
</ng-template>
